module.exports = __webpack_public_path__ + "static/media/Halfling.a615b2a8.png";